import publicConfig from '@/config/public'

const buildAssetsPath = (path: string): string => {
  /* istanbul ignore next */
  return `${publicConfig.publicAssetPrefix ?? ''}${path}`
}

export { buildAssetsPath }
